/*
 *
 * Basic Theme
 *
 */

import "./scss/style.scss";
//import './js/video-component';
import "./js/filters";
import "./js/header-top"
import "./js/main-menu"
import "./js/news-archive"

import "./js/icons/svgxuse.min.js";
require.context("./images", true);
